document.addEventListener("DOMContentLoaded", () => {
  const quizPopupTriggers = document.querySelectorAll('.quiz-popup-trigger');

  quizPopupTriggers.forEach(trigger => {
    const quizSection = document.getElementById('quiz-section');

    if (quizSection) {
      trigger.addEventListener('click', () => {
        quizSection.scrollIntoView({ behavior: 'smooth' });
      });
    } else {
      trigger.addEventListener('click', () => {
        showQuizPopup(window.quizData);

        window.quizData.previousType = window.quizData.type;
        window.quizData.type = 'popup';

        showQuizStep1(window.quizData);
      });
    }
  });

  if (window.innerWidth <= 650) {
    const quizPopupKey = `quizPopupLastShown`;

    setTimeout(() => {
      const now = Date.now();
      const last = parseInt(localStorage.getItem(quizPopupKey), 10);

      if (!last || now - last > 1 * 60 * 60 * 1000) {
        showQuizPopup(window.quizData);

        window.quizData.previousType = window.quizData.type;
        window.quizData.type = 'popup';

        showQuizStep1(window.quizData);
        localStorage.setItem(quizPopupKey, now);
      }
    }, 2 * 1000);
  }
});

const showQuizPopup = (d) => {
  d.popupOpen = true;
  const quizPopup = document.getElementById('quiz-popup');
  quizPopup.style.display = 'flex';

  document.body.style.overflow = 'hidden';

  openQuiz();
}

const hideQuizPopup = (d) => {
  d.popupOpen = false;
  const quizPopup = document.getElementById('quiz-popup');
  quizPopup.style.display = 'none';

  document.body.style.overflow = 'auto';
}
